import Vue from 'vue';
import moment from 'moment';
Vue.filter('time', function (data, formatString) {
  return data ? moment(data).format('YYYY-MM-DD') : '';
})



//////////////////
// WEBPACK FOOTER
// ./static/js/time.js
// module id = 265
// module chunks = 1